import { TEXT } from "../talentMobility.constants";

export const PRIORITY_TAG_COLOR = { High: "warning", Normal: "default", Low: "default" };

export const PLANNING_TOOLS_MENU_ITEMS = [
  { key: "redeployment", label: TEXT.BTN_REDEPLOYMENT_CENTER },
  { key: "workforce", label: TEXT.BTN_WORKFORCE_PLANNING },
  { key: "viewPlanning", label: TEXT.BTN_VIEW_PLANNING },
];

export const PLANNING_TOOLS_ROUTES = {
  redeployment: "/talent-mobility/redeployment-center",
  workforce: "/talent-mobility/workforce-planning",
  viewPlanning: "/talent-mobility/view-planning",
};
